import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useLoggedInUserStore = defineStore("loggedInUser", () => {
  const userName = ref("");
  const fullName = ref("");
  const accessToken = ref("");
  const isLoggedIn = ref(false);
  const userPermissions = ref([]);

  const loggedInUserName = computed(() => userName.value);
  const azureAccessToken = computed(() => accessToken.value);
  const getCurrentUser = computed(() => ({
    userName: userName.value,
    fullName: fullName.value,
    accessToken: accessToken.value,
    isUserLoggedIn: isLoggedIn.value,
    permissions: userPermissions.value,
  }));

  function setCurrentUser(user) {
    userName.value = user.userName;
    fullName.value = user.fullName;
    accessToken.value = user.accessToken;
    isLoggedIn.value = user.isUserLoggedIn;
    userPermissions.value = user.permissions?.split(",") || [];
  }

  function hasPermission(permission) {
    return userPermissions.value.some((x) => x === permission);
  }

  return {
    userName,
    fullName,
    accessToken,
    isLoggedIn,
    userPermissions,
    loggedInUserName,
    azureAccessToken,
    getCurrentUser,
    setCurrentUser,
    hasPermission,
  };
});
